/**
 * The Enum which defines all possible Calendar view types.
 */
export var CalendarViewEnum;

(function (CalendarViewEnum) {
  CalendarViewEnum[CalendarViewEnum["month"] = 0] = "month";
  CalendarViewEnum[CalendarViewEnum["year"] = 1] = "year";
  CalendarViewEnum[CalendarViewEnum["decade"] = 2] = "decade";
  CalendarViewEnum[CalendarViewEnum["century"] = 3] = "century";
})(CalendarViewEnum || (CalendarViewEnum = {}));